export const STANDARD_PAYMENT_URL = "https://rzp.io/rzp/bloomparentify";
export const DISCOUNT_PAYMENT_URL = "INSERT_DISCOUNT_PAYMENT_LINK_HERE";
export const DISCOUNT_CODE = "BLOOM10";
// High-intent 10% discount experience. Disabled for launch — flip to true to re-enable.
export const DISCOUNT_ENABLED = false;
export const SITE_URL = "https://bloomparentify.com";

export const PRICE = "$47";
export const CORE_VALUE = "$197";
export const SAVINGS = "$150";
export const DISCOUNT = { percent: "10%", price: "$42.30", savings: "$4.70" };

export const BRAND = {
  name: "BloomParentify",
  tagline: "Less chaos. More room for what matters.",
  product: "The BloomParentify Working Mom System",
};

export const CTA = {
  primary: "Get the BloomParentify System",
  primaryShort: "Get the System",
  microcopy: "Complete digital bundle • Instant access",
};

export const NAV_LINKS = [
  { label: "What's Inside", href: "#whats-inside" },
  { label: "Life System", href: "#life-system" },
  { label: "AI Side Hustle", href: "#ai-side-hustle" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "FAQ", href: "#faq" },
];

export const VALUE_STRIP = [
  { value: "9", label: "Digital resources" },
  { value: "2", label: "Core solutions" },
  { value: CORE_VALUE, label: "Core value" },
  { value: PRICE, label: "Today" },
  { value: "Instant", label: "Digital access" },
];

export const PAIN_POINTS = [
  { title: "Too much to remember", text: "Every responsibility has a way of ending up in your head." },
  { title: "No time for yourself", text: "By the time everyone else is taken care of, your own priorities get pushed back." },
  { title: "Routines that don't stick", text: "Real life interrupts even the best plans." },
  { title: "Always feeling behind", text: "You can accomplish a lot and still feel like you didn't do enough." },
  { title: "Your own goals keep waiting", text: "You want to grow, create and earn—but finding the time feels impossible." },
  { title: "Side-hustle overwhelm", text: "You know AI is creating opportunities, but you don't know where to start or how to fit it around your life." },
];

export const CORE_SOLUTIONS = [
  {
    id: "life-system",
    number: "01",
    tag: "Core Solution — The Life System",
    name: "Balanced Working Mom Planner",
    headline: "Get your life out of your head.",
    copy: "A practical planning system for organizing work, family responsibilities, routines, priorities and personal time—without turning your life into a rigid schedule.",
    benefits: [
      "Organize what matters",
      "Simplify daily planning",
      "Reduce mental clutter",
      "Make room for yourself",
    ],
    cta: "See the Life System",
    event: "core_planner_click",
    image: "/assets/products/planner.jpg",
    alt: "The Balanced Working Mom Planner cover",
  },
  {
    id: "ai-side-hustle",
    number: "02",
    tag: "Core Solution — The Opportunity System",
    name: "AI Side Hustle Guide",
    headline: "Your next opportunity doesn't have to become another full-time job.",
    subheadline: "How to Build a Profitable AI Side Hustle That Fits Your Life",
    copy: "AI is opening new ways to create, sell and work—but finding an opportunity that actually fits around a job and family is a different challenge.\n\nThis guide helps you explore practical AI side-hustle models and think through how they can fit your available time, skills and goals.",
    benefits: [
      "Understand practical AI side-hustle models",
      "Identify opportunities that fit limited time",
      "Learn how AI can reduce the work required",
      "Start with a realistic direction instead of chasing every trend",
    ],
    cta: "Explore the AI Side-Hustle Guide",
    event: "ai_side_hustle_click",
    image: "/assets/products/hustle.jpg",
    alt: "AI Side Hustle Guide cover — How to Build a Profitable AI Side Hustle That Fits Your Life",
  },
];

export const SUPPORTING_TOOLS = [
  {
    number: "03",
    name: "Working Mom Command Center",
    cats: ["life"],
    description: "Bring important family and household information into one easier-to-manage place.",
    benefit: "Carry less in your head.",
    image: "/assets/products/command.jpg",
    alt: "Working Mom Command Center cover",
  },
  {
    number: "04",
    name: "Little Genius Calm Play Book",
    cats: ["family"],
    description: "Practical activity ideas for children ages 2–10, ready when you need them.",
    benefit: "Useful activities without hours of searching.",
    image: "/assets/products/play.jpg",
    alt: "Little Genius Calm Play Book cover",
  },
  {
    number: "05",
    name: "Quick-Lunch Cookbook",
    cats: ["family", "life"],
    description: "Quick, practical lunch ideas for days when deciding what to make is one decision too many.",
    benefit: "Make busy-day meals simpler.",
    image: "/assets/products/cookbook.jpg",
    alt: "Quick-Lunch Cookbook cover",
  },
  {
    number: "06",
    name: "7-Day Self-Care Reset",
    cats: ["self"],
    description: "A realistic short reset built around small acts of care that fit a busy week.",
    benefit: "Reclaim small amounts of personal time.",
    image: "/assets/products/selfcare.jpg",
    alt: "7-Day Self-Care Reset cover",
  },
  {
    number: "07",
    name: "28-Day Routine Reset",
    cats: ["life", "time"],
    description: "A practical framework for more consistent routines—without demanding perfection.",
    benefit: "Structure that adapts to real life.",
    image: "/assets/products/routine.jpg",
    alt: "28-Day Routine Reset cover",
  },
  {
    number: "08",
    name: "60 Productivity Hacks",
    cats: ["time", "opportunity"],
    description: "Practical productivity strategies designed around limited time and real responsibilities.",
    benefit: "Use available time more intentionally.",
    image: "/assets/products/hacks.jpg",
    alt: "60 Productivity Hacks cover",
  },
  {
    number: "09",
    name: "Pocket Planner",
    cats: ["life", "time"],
    description: "A compact planning tool for quick daily organization, wherever you are.",
    benefit: "Keep priorities accessible when life gets busy.",
    image: "/assets/products/pocket.jpg",
    alt: "Pocket Planner cover",
  },
];

export const ECOSYSTEM = [
  { label: "Plan", tool: "Balanced Working Mom Planner" },
  { label: "Organize", tool: "Working Mom Command Center" },
  { label: "Routine", tool: "28-Day Routine Reset" },
  { label: "Productivity", tool: "60 Productivity Hacks" },
  { label: "Meals", tool: "Quick-Lunch Cookbook" },
  { label: "Kids", tool: "Little Genius Calm Play Book" },
  { label: "Self-Care", tool: "7-Day Self-Care Reset" },
  { label: "Daily", tool: "Pocket Planner" },
  { label: "Grow", tool: "AI Side Hustle Guide" },
];

export const BENEFITS = [
  { number: "01", title: "Clearer days", text: "Know what deserves your attention instead of carrying everything at once." },
  { number: "02", title: "Less mental clutter", text: "Give recurring responsibilities a place outside your head." },
  { number: "03", title: "Simpler routines", text: "Create structure without creating another burden." },
  { number: "04", title: "More room for yourself", text: "Stop treating your own priorities as optional." },
  { number: "05", title: "More intentional productivity", text: "Use limited time more deliberately." },
  { number: "06", title: "More opportunity", text: "Explore ways AI can help you create something of your own around your existing life." },
];

export const STEPS = [
  { number: "01", title: "Start with your biggest pressure", text: "Choose the resource that solves the problem you are facing right now." },
  { number: "02", title: "Make it fit your life", text: "Use the tools around your schedule, responsibilities, family and goals." },
  { number: "03", title: "Build from there", text: "Keep what works, adapt what doesn't and gradually create a system that supports both your everyday life and your bigger goals." },
];

export const WHO_CHECKLIST = [
  "You work and parent at the same time.",
  "You feel like you're constantly managing something.",
  "You want better routines without rigid schedules.",
  "You want more organization without another complicated system.",
  "You want to make more room for yourself.",
  "You've thought about creating an additional income stream.",
  "You're curious about AI but don't know how to turn it into something practical.",
  "You want to build something without sacrificing your family life.",
];

export const TRUST_PRINCIPLES = [
  { title: "Practical", text: "Tools designed to be used—not admired and forgotten." },
  { title: "Flexible", text: "Use what fits your life. Skip what doesn't." },
  { title: "Feminine + Ambitious", text: "Built around the reality that you can care deeply for your family and still want more for yourself." },
];

export const OBJECTIONS = [
  {
    q: "“I don't have time for another system.”",
    a: "That's why you don't have to use everything at once. Start with the tool that solves the biggest problem in front of you.",
  },
  {
    q: "“I've bought planners before.”",
    a: "The planner is only one part of BloomParentify. The system is designed around the wider reality of working motherhood.",
  },
  {
    q: "“I don't know anything about AI.”",
    a: "You don't need to be an AI expert. The guide is designed to help you understand practical opportunities and where AI can fit into them.",
  },
  {
    q: "“AI side hustles sound like a lot of work.”",
    a: "The goal isn't to create another full-time job. The guide focuses on opportunities that can be evaluated around your existing time, skills and responsibilities.",
  },
  {
    q: "“Can't I find this information for free?”",
    a: "Free information is everywhere. The challenge is knowing what matters, what fits your life and how to organize it into something practical. BloomParentify brings the tools together in one place.",
  },
  {
    q: "“I won't use everything.”",
    a: "You don't have to. The system is modular. Use what you need when you need it.",
  },
  {
    q: "“My life is too unpredictable.”",
    a: "That's exactly why the system is flexible. Your tools should adapt when real life changes.",
  },
];

export const FAQS = [
  {
    q: "What exactly do I get?",
    a: "You get the complete BloomParentify System with nine digital resources: the Balanced Working Mom Planner, AI Side Hustle Guide, Working Mom Command Center, Little Genius Calm Play Book, Quick-Lunch Cookbook, 7-Day Self-Care Reset, 28-Day Routine Reset, 60 Productivity Hacks and Pocket Planner.",
  },
  {
    q: "What is the AI Side Hustle Guide?",
    a: "It is an educational guide called 'How to Build a Profitable AI Side Hustle That Fits Your Life.' It explores practical AI-powered side-hustle opportunities and how to evaluate them around your available time, skills and goals.",
  },
  {
    q: "Do I need AI experience?",
    a: "No. The guide is designed for beginners and focuses on understanding practical opportunities rather than requiring advanced technical knowledge.",
  },
  {
    q: "Do I have to complete everything?",
    a: "No. The system is modular. Start with whatever resource is most useful to you right now.",
  },
  {
    q: "Is this a physical product?",
    a: "No. BloomParentify is a digital product bundle. You receive digital access after purchase.",
  },
  {
    q: "What ages is the children's content for?",
    a: "The Little Genius Calm Play Book is designed for children approximately ages 2–10.",
  },
  {
    q: "Is this only for full-time working moms?",
    a: "No. It can also be useful for mothers working part-time, remotely, freelancing, running a business or managing other demanding responsibilities.",
  },
  {
    q: "How much does the complete system cost?",
    a: "The complete system is currently $47, with a stated core value of $197.",
  },
];

export const VERIFIED_TESTIMONIALS = [];

export const MENTAL_LOAD = [
  "Work", "Kids", "Meals", "School", "Home",
  "Deadlines", "Routines", "Your goals", "Money", "Time",
];

export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "life", label: "Life" },
  { id: "family", label: "Family" },
  { id: "time", label: "Time" },
  { id: "self", label: "Self" },
  { id: "opportunity", label: "Opportunity" },
];

export const AI_JOURNEY = [
  { stage: "Idea", text: "Find an opportunity that fits your life." },
  { stage: "AI", text: "Use AI to reduce repetitive work." },
  { stage: "Create", text: "Turn ideas into useful products or services." },
  { stage: "Build", text: "Develop something around your existing schedule." },
  { stage: "Opportunity", text: "Explore a new path without pretending you have unlimited time." },
];
